import {
    ChargemasterApi,
    CoreFetch,
    ListProviderChargemasterItemsRequest,
    ListProviderChargemastersRequest,
    ProviderChargemaster,
} from '@enter/core';
import { IChargemasterDetail, IChargemasterListing } from './chargemaster.store';
import { fetch, parseResponse } from './util';

export class ChargemasterService {
    public async fetchChargemasterListing(
        lpcr: ListProviderChargemastersRequest,
    ): Promise<IChargemasterListing | undefined> {
        const res = await fetch(lpcr, req =>
            CoreFetch<ChargemasterApi>(ChargemasterApi).listProviderChargemastersRaw(req),
        );
        if (res) {
            return {
                chargemasters: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }
    public async fetchChargemaster(id: string): Promise<ProviderChargemaster | undefined> {
        return fetch({ id }, req => CoreFetch<ChargemasterApi>(ChargemasterApi).getProviderChargemaster(req));
    }
    public async fetchChargemasterDetail(
        lpcir: ListProviderChargemasterItemsRequest,
    ): Promise<IChargemasterDetail | undefined> {
        const res = await fetch(lpcir, req =>
            CoreFetch<ChargemasterApi>(ChargemasterApi).listProviderChargemasterItemsRaw(req),
        );
        if (res) {
            return {
                chargemasterItems: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }
}
